import React, { useEffect, useState } from "react";
import { Row, Col, Button, Image, Badge } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import Element from '../InputFields/input';
import { FormContext } from '../InputFields/FormContext';
import './workflowModals.css';
import Scheduler from '../Scheduler/scheduler'

export default function BotWorkflowModal(props) {
    // console.log("BOT WORKFLOW MODAL PROPS:", props)
    const fullModal = props.fullmodal
    const workflowid = props.recommendation.workflow.FlowId
    const workflowname = props.recommendation.workflow.FlowName
    const sourceFormSchema = props.recommendation.workflow.FormSchema.SourceFormSchema
    const targetFormSchema = props.recommendation.workflow.FormSchema.TargetFormSchema
    const [sourceFullSchema, setSourceFullSchema] = useState(sourceFormSchema)
    const [targetFullSchema, setTargetFullSchema] = useState(targetFormSchema)
    const [sourceElements, setSourceElements] = useState(sourceFullSchema);
    const [targetElements, setTargetElements] = useState(targetFullSchema);
    const [scheduleElements, setScheduleElements] = useState(targetFullSchema);
    const [checkboxId, setCheckboxId] = useState("")
    const [schedulerFormcontext, setSchedulerFormcontext] = useState([])
    const [schedulerSchema, setScheduleCheck] = useState(props.recommendation.workflow.FormSchema.schedule?props.recommendation.workflow.FormSchema.schedule:true)
    const [scheduleModal, setScheduleModal] = useState(false)
    const [buttonClickedState, setButtonClickedState] = useState(false)
    useEffect(() => {
        console.log("SCHEDULER SCHEMA BOT: ", schedulerSchema)
      }, [schedulerSchema])
      
    const showScheduleModal = () => {
        console.log()
        setScheduleModal(!scheduleModal)
    }

    const getScheduler = (value) => {
        setSchedulerFormcontext(value)
    }

    useEffect(() => {
        for (let field_index in sourceElements) {
            if (sourceElements[field_index].type == "checkbox") {
                setCheckboxId(sourceElements[field_index].id)
                if (sourceElements[field_index].value == false || sourceElements[field_index].value == undefined) {
                    sourceElements.forEach((field, index) => {
                        if (index > field_index) {
                            field["disabled"] = true
                        }
                    });
                } else {
                    sourceElements.forEach((field, index) => {
                        if (index > field_index) {
                            field["disabled"] = false
                        }
                    });
                }
            }
        }

        for (let field_index in targetElements) {
            if (targetElements[field_index].type == "checkbox") {
                setCheckboxId(targetElements[field_index].id)
                if (targetElements[field_index].value == false || targetElements[field_index].value == undefined) {
                    targetElements.forEach((field, index) => {
                        if (index > field_index) {
                            field["disabled"] = true
                        }
                    });
                } else {
                    targetElements.forEach((field, index) => {
                        if (index > field_index) {
                            field["disabled"] = false
                        }
                    });
                }
            }
        }
    }, [])

    const handleSubmit = (event, add) => {
        if (!buttonClickedState) {
            if (add) { console.log("ADDED!") }
            event.preventDefault();
            props.handleworkflowsave(workflowid, workflowname, sourceElements, targetElements, schedulerFormcontext)
            setButtonClickedState(!buttonClickedState)
        } else {
            alert("Workflow is being saved, please wait.")
        }
    }

    const runBotNow = (event) => {
        event.preventDefault()
        console.log("RUNNING THE BOT NOW!")
    }

    const handleChange = (field_id, event) => {
        const newSourceElements = [...sourceElements]
        newSourceElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW ELEMENTS on CHANGE: ", newSourceElements)
            const newSourceFullSchema = [...newSourceElements]
            // console.log("NEW FULL SCHEMA: ", newSourceFullSchema)
            setSourceElements(newSourceFullSchema)
        });

        const newTargetElements = [...targetElements]
        newTargetElements.forEach(field => {
            const { type, id } = field;
            if (field_id === id) {
                switch (type) {
                    case 'checkbox':
                        field['value'] = event.target.checked;
                        break;

                    case 'select':
                        field['value'] = event.value;
                        break;

                    case 'date':
                        field['value'] = event;
                        break;

                    default:
                        field['value'] = event.target.value;
                        break;
                }
            }
            // console.log("NEW ELEMENTS on CHANGE: ", newTargetElements)
            const newTargetFullSchema = [...newTargetElements]
            // console.log("NEW FULL SCHEMA: ", newTargetFullSchema)
            setTargetElements(newTargetFullSchema)
        });
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className={fullModal ? "workflow-modal" : "smallmodal"}
        >
            <Modal.Header closeButton className="modal-header-title">
                {
                    fullModal
                        ?
                        <h2>{props.recommendation.workflow.FlowName}</h2>
                        :
                        <h6>{props.recommendation.workflow.FlowName}</h6>
                }
                <h6>{props.recommendation.workflow.FlowDescription}</h6>
            </Modal.Header>
            <Modal.Body>
                {
                    fullModal ?
                        <Row className="body-layer">
                            <Row>
                                <Col md={3} className="">
                                    <Row>
                                        <div className="workflow-modal-logo">
                                            <Image src={props.recommendation.workflow.SourceVendors[0].VendorLogoLink} className="recommended-vendor-logo" rounded />
                                            <div className="workflow-name">
                                                <h6>{props.recommendation.workflow.SourceVendors[0].VendorName}</h6>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col md={7}>
                                    <Row className="flow-container">
                                        <Row className="flow-wrapper">
                                            <Col md={6} className="bot-tbl rainbow"></Col>
                                        </Row>
                                    </Row>
                                </Col>
                                <Col md={1}></Col>
                                <Col md={1} className="flex-column-center-start">
                                    {
                                        <div className="flex-row-center-start" style={{ marginTop: 20, fontWeight: 600 }}>
                                            <p>Would you like to schedule this flow? </p>
                                            <input type="checkbox"
                                                className={"form-check-input move-left custom-check-input"} id="exampleCheck3"
                                                checked={schedulerSchema}
                                                onChange={event => setScheduleCheck(event.target.checked)}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    }
                                    <Button type="submit" className="schedule-workflow-button move-right" onClick={(e) => showScheduleModal(!scheduleModal)}>Schedule</Button>
                                    <div className={scheduleModal ? "bot-schedule-holder" : "bot-schedule-holder hidden-scheduler"}>
                                        {
                                            schedulerSchema ?
                                                <Row className="no-gutter pad-trbl-10">
                                                    <Scheduler getscheduler={getScheduler} />
                                                </Row>
                                                : <></>
                                        }
                                    </div>
                                    <Button type="submit" className="intel-workflow-save-button move-right" onClick={(e) => handleSubmit(e)}>Submit</Button>

                                </Col>
                            </Row>
                            <Row>
                                <Col md={2}></Col>
                                <Col md={8}>
                                    <Row className="bot-workflow-action-container-wrapper">
                                        <Col md={4} className="bot-workflow-action-container-parent">
                                            <Row className="action-input-row">
                                                <div className="bot-workflow-action-container">
                                                    <FormContext.Provider value={{ handleChange }}>
                                                        <Form className="bot-form">
                                                            <Row>
                                                                {
                                                                    sourceElements &&
                                                                    sourceElements.map((field, i) =>
                                                                        <Element
                                                                            key={i}
                                                                            field={field}
                                                                            md={
                                                                                field.type == "text" || field.type == "password"
                                                                                    ?
                                                                                    12
                                                                                    :
                                                                                    6}
                                                                        />)
                                                                }
                                                            </Row>
                                                        </Form>
                                                    </FormContext.Provider>
                                                </div>
                                            </Row>
                                        </Col>
                                        <Col md={1} className="flex-column-center-center">
                                            <div className="rainbow intel-anime-line"></div>
                                        </Col>
                                        <Col md={2} className="flex-column-center-center">
                                            <Row className="bot-cai">
                                                <div className="workflow-modal-logo">
                                                    <Image src={props.recommendation.workflow.SourceVendors[0].VendorLogoLink} className="recommended-vendor-logo" rounded />
                                                    <div className="workflow-name">
                                                        <h6>{props.recommendation.workflow.SourceVendors[0].VendorName}</h6>
                                                    </div>
                                                </div>
                                            </Row>
                                        </Col>
                                        <Col md={1} className="flex-column-center-center">
                                            <div className="rainbow intel-anime-line"></div>
                                        </Col>
                                        <Col md={4} className="bot-workflow-action-container-parent">
                                            <div className="bot-workflow-action-container">
                                                <Row className="action-input-row">
                                                    <FormContext.Provider value={{ handleChange }}>
                                                        <Form className="bot-form">
                                                            <Row>
                                                                {
                                                                    targetElements &&
                                                                    targetElements.map((field, i) =>
                                                                        <Element
                                                                            key={i}
                                                                            field={field}
                                                                            md={
                                                                                field.type == "text" || field.type == "password"
                                                                                    ?
                                                                                    12
                                                                                    :
                                                                                    6}
                                                                        />)
                                                                }
                                                            </Row>
                                                        </Form>
                                                    </FormContext.Provider>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={2}>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}></Col>
                                <Col md={6}>
                                    <Row className="flow-container">
                                        <Row className="flow-wrapper">
                                            <Col md={6} className="bot-ltr rainbow2"></Col>
                                        </Row>
                                    </Row>
                                </Col>
                                <Col md={3}>
                                    <Row>
                                        <div className="workflow-modal-logo">
                                            <div className="workflow-name">
                                                <h6>{props.recommendation.workflow.TargetVendors[0].VendorName}</h6>
                                            </div>
                                            <Image src={props.recommendation.workflow.TargetVendors[0].VendorLogoLink} className="recommended-vendor-logo" rounded />
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Row>
                        :
                        <FormContext.Provider value={{ handleChange }}>
                            <Form>
                                <Row className="no-gutter">
                                    <Col md={6} style={{ display: "flex", flexDirection: "column" }}>
                                        <Image
                                            src={props.recommendation.workflow.SourceVendors[0].VendorLogoLink}
                                            className="vendor-logo-micro"
                                            rounded
                                        />
                                        {
                                            sourceElements &&
                                            sourceElements.map((field, i) =>
                                                <Element
                                                    key={i}
                                                    field={field}
                                                    md={
                                                        field.type == "text" || field.type == "password"
                                                            ?
                                                            12
                                                            :
                                                            6}
                                                />)
                                        }
                                    </Col>
                                    <Col md={6} style={{ display: "flex", flexDirection: "column" }}>
                                        <Image
                                            src={props.recommendation.workflow.TargetVendors[0].VendorLogoLink}
                                            className="vendor-logo-micro text-center"
                                            rounded
                                        />
                                        {
                                            targetElements &&
                                            targetElements.map((field, i) =>
                                                <Element
                                                    key={i}
                                                    field={field}
                                                    md={
                                                        field.type == "text" || field.type == "password"
                                                            ?
                                                            12
                                                            :
                                                            6}
                                                />)
                                        }
                                    </Col>
                                </Row>
                                {
                                    <div className="flex-row-center-start" style={{ marginTop: 20, fontWeight: 600 }}>
                                        <p>Would you like to schedule this flow? </p>
                                        <input type="checkbox"
                                            className={"form-check-input move-left custom-check-input"} 
                                            id="exampleCheck3"
                                            checked={schedulerSchema}
                                            onChange={event => setScheduleCheck(event.target.checked)}
                                            autoComplete="new-password"
                                        />
                                    </div>
                                }
                                {
                                    schedulerSchema ?
                                        <Row className="no-gutter pad-trbl-10">
                                            <h5>Schedule</h5>
                                            <Scheduler getscheduler={getScheduler} />
                                        </Row>
                                        : <></>
                                }
                                <Row className="workflow-modal-other-info">
                                    <Col xs={4}>
                                    </Col>
                                    <Col xs={4}></Col>
                                    <Col md={4}>
                                        <Button type="submit" className="workflow-save-button move-right" onClick={(e) => handleSubmit(e)}>Submit</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </FormContext.Provider>
                }
            </Modal.Body>
            <Modal.Footer className="workflow-footer">
            </Modal.Footer>
        </Modal>
    );
}